import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCohort = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.704 7.704a2.222 2.222 0 1 1 4.444 0 2.222 2.222 0 0 1-4.444 0ZM7.926 4a3.704 3.704 0 1 0 0 7.407 3.704 3.704 0 0 0 0-7.407Zm7.407 4.444a1.481 1.481 0 1 1 2.963 0 1.481 1.481 0 0 1-2.963 0Zm1.482-2.962a2.963 2.963 0 1 0 0 5.925 2.963 2.963 0 0 0 0-5.925Zm-5.185 7.407c.042 0 .084 0 .126.003a2.222 2.222 0 0 0 .004 1.49l-.13-.012H4.222a.74.74 0 0 0-.74.741v.144l.005.072c.058.46.23.896.501 1.27.483.664 1.535 1.477 3.938 1.477 2.092 0 3.16-.616 3.718-1.215.057.465.255.885.552 1.215-.142.158-.26.335-.352.526-.896.567-2.158.956-3.918.956-2.782 0-4.323-.97-5.136-2.088a4.222 4.222 0 0 1-.775-1.988A2.957 2.957 0 0 1 2 15.277v-.166a2.222 2.222 0 0 1 2.222-2.222h7.408Zm2.222 0a.74.74 0 0 0 0 1.481h7.407a.74.74 0 1 0 0-1.481h-7.407Zm0 2.963a.74.74 0 1 0 0 1.481h7.407a.74.74 0 1 0 0-1.481h-7.407Zm0 2.963a.74.74 0 1 0 0 1.481h7.407a.74.74 0 1 0 0-1.481h-7.407Z",
		fill: "currentColor"
	})
});
export default SvgCohort;
